import { SelectProps, Select, MenuItem } from '@mui/material'
import { Checkbox, Typography } from '@vapor/material'
import { useState, useEffect } from 'react'
import { ChargeCategoryFragment, useChargeCategoriesQuery } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'

type ChargeCategoriesMultipleSelectProps = Omit<SelectProps, 'onChange' | 'value' | 'disabled' | 'error'> & {
  value: string[]
  onChange: (value: string[]) => void
  onChangeChargeCategory?: (value: ChargeCategoryFragment[]) => void
  error: string | undefined
  disabled: boolean
  propertyId: string
  addEmptyOption?: true
}

export function ChargeCategoriesMultipleSelect(props: ChargeCategoriesMultipleSelectProps) {
  const { id: tenantId } = useTenant()
  const { value, onChange, error, disabled, propertyId, addEmptyOption, onChangeChargeCategory, ...otherProps } = props

  const [selectedChargeCategoriesId, setSelectedChargeCategoriesId] = useState<string[]>([])
  const { data, loading: loadingChargeCategory } = useChargeCategoriesQuery({
    variables: {
      filter: {
        tenantId: {
          eq: tenantId,
        },
        propertyId: {
          eq: propertyId,
        },
      },
    },
    onCompleted: (data) => {
      const ccIds = data?.chargeCategories?.map((cc) => cc.id)
      if (ccIds && value && value.length > 0 && selectedChargeCategoriesId.length === 0) {
        const tmp = value.filter((v) => ccIds.includes(v))
        setSelectedChargeCategoriesId(tmp)
      }
    },
  })

  useEffect(() => {
    if (JSON.stringify(value) !== JSON.stringify(selectedChargeCategoriesId)) {
      onChange(selectedChargeCategoriesId)
    } else if (addEmptyOption) {
      onChange(selectedChargeCategoriesId.length <= 0 ? [] : selectedChargeCategoriesId)
    }
  }, [selectedChargeCategoriesId])

  useEffect(() => {
    if (JSON.stringify(value) !== JSON.stringify(selectedChargeCategoriesId)) {
      setSelectedChargeCategoriesId(value)
    }
  }, [value])

  return (
    <Select
      {...otherProps}
      value={selectedChargeCategoriesId}
      onChange={(event) => {
        const newSelectionIds = event.target.value as string[]
        setSelectedChargeCategoriesId(newSelectionIds)
        const selectedCC = data?.chargeCategories?.filter((v) => newSelectionIds.includes(v.id))
        if (onChangeChargeCategory) onChangeChargeCategory(selectedCC ?? [])
      }}
      error={error !== undefined}
      disabled={disabled || loadingChargeCategory}
      renderValue={(selected) => ((selected as string[] | undefined | null) ?? []).map((id) => data?.chargeCategories?.find((cc) => cc.id === id)?.name).join(', ')}
      multiple
    >
      {addEmptyOption && <MenuItem key={''} value={''} style={{ height: 44 }}></MenuItem>}
      {data?.chargeCategories
        ?.filter((x): x is ChargeCategoryFragment => x !== null)
        .filter((cc) => cc.stayIncluded)
        .map((chargeCategory) => (
          <MenuItem key={chargeCategory.id} value={chargeCategory.id}>
            <Checkbox size="small" checked={selectedChargeCategoriesId.indexOf(chargeCategory.id) > -1} />
            <Typography variant="body">{chargeCategory?.name}</Typography>
          </MenuItem>
        ))}
    </Select>
  )
}
